import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    SPENDBACKS_FAILURE,
    SPENDBACKS_LOAD,
    SPENDBACKS_SUCCESS
} from './spendbacksActions';
import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                spendbacks: []
            };

            return isEqual(state, newState) ? state : newState;

        case SPENDBACKS_LOAD:
            newState = {
                ...state,
                spendbacks: [],
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case SPENDBACKS_SUCCESS:
            newState = {
                ...state,
                spendbacks: action.spendbacks,
                count: action.count,
                loading: false,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case SPENDBACKS_FAILURE:
            newState = {
                ...state,
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;
        default:
            return state;
    }
}

export const getSpendbacksEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'spendbacks')
);

export const getPages = createSelector(
    getSpendbacksEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getSpendbacksEntity,
    (entity) => get(entity, 'count')
);

export const getIsSpendbacksLoading = createSelector(
    getSpendbacksEntity,
    (entity) => get(entity, 'loading')
);

export const getSpendbacks = createSelector(
    getSpendbacksEntity,
    (entity) => get(entity, 'spendbacks')
);

export const getSpendbacksError = createSelector(
    getSpendbacksEntity,
    (entity) => get(entity, 'error')
);

export const getSpendbacksErrorMessage = createSelector(
    getSpendbacksError,
    (error) => get(error, 'message')
);

export const getHasMore = createSelector(
    getSpendbacksEntity,
    (entity) => get(entity, 'hasMore')
);
